import css from 'styled-jsx/css';

const styles = css.global`.modal-termos {
  display: none;
  pointer-events: none;
  visibility: hidden;
  opacity: 0;
}

.modal-termos.open {
  display: flex;
  pointer-events: unset;
  visibility: visible;
  opacity: 1;
}

.modal-termos .overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  z-index: 9999;
  border: none;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  background: transparent;

  align-items: center;
  justify-content: center;

  background: #606060;
  background-blend-mode: multiply;
  mix-blend-mode: multiply;
}

.modal-termos .frame {
  background: #fff;
  border: 1px solid #cccccc;
  border-radius: 4px;
  box-shadow: 0px 2px 16px -2px #22222266;
  background-blend-mode: normal;
  mix-blend-mode: normal;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000;

  width: 100%;
  max-width: calc(100% - 32px);
  min-height: 656px;
  padding: 24px;
  box-sizing: border-box;
}

.modal-termos .content {
  position: relative;
}

.modal-termos .content .modal-title {
  font-family: 'SantanderHeadline';
  font-weight: 400;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0px;
  color: #222222;
  margin-bottom: 53px;
}

.modal-termos #btn-close-terms {
  position: absolute;
  top: -8px;
  right: -8px;
  padding: 16px;
  transform: translate(16px, -16px);
}

.modal-termos .content .text-row-header {
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0px;
  color: #222222;
}

.modal-termos .content .render-terms {
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 18;
  line-height: 20px;
  letter-spacing: 0px;
  color: #767676;
  padding: 4px 4px 4px 0;
}

.modal-termos .content .render-terms * {
  font: inherit;
  color: inherit;
}

.modal-termos .content .render-terms h1,
.modal-termos .content .render-terms h2,
.modal-termos .content .render-terms h3,
.modal-termos .content .render-terms h4,
.modal-termos .content .render-terms h5,
.modal-termos .content .render-terms h6,
.modal-termos .content .render-terms b {
  font-weight: 600;
}

.modal-termos .content .modal-body {
  max-height: 361px;
  overflow: auto;
  margin-bottom: 87px;
}

.modal-termos .loading-indicator {
  display: block;
  margin: 0 auto;
}

.modal-termos .content .render-terms table td {
  vertical-align: top;
  padding: 4px;
  min-width: 200px;
}

.modal-termos .content .render-terms table td p {
  font-size: 14px;
}

.modal-termos .content .render-terms table tr:first-of-type td p {
  font-size: 16px;
  font-weight: bold;
}

@media (min-width: 992px) {
  .modal-termos .frame {
    max-width: 768px;
  }
}

@media (max-width: 991px) {
  .modal-termos .frame {
    min-height: min(90vh, 656px);
  }
}

@media (max-height: 660px) {
  .modal-termos .frame {
    min-height: 520px;
    display: flex;
  }

  .modal-termos .content {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 24px;
  }

  .modal-termos .content .modal-title,
  .modal-termos .content .modal-body {
    margin-bottom: 0;
    margin-top: 0;
  }

  .modal-termos .content .modal-body {
    max-height: 330px;
  }

  .modal-termos #btn-accept-terms {
    align-self: flex-end;
    margin-top: auto;
  }
}

@media (max-height: 540px) {
  .modal-termos .frame {
    min-height: 460px;
  }

  .modal-termos .content .modal-body {
    max-height: 280px;
  }
}

@media (max-height: 470px) {
  .modal-termos .frame {
    min-height: 380px;
  }

  .modal-termos .content .modal-body {
    max-height: 230px;
  }
}

@media (max-height: 390px) {
  .modal-termos .frame {
    min-height: 300px;
  }

  .modal-termos .content {
    gap: 16px;
  }

  .modal-termos .content .modal-body {
    max-height: 180px;
  }
}
`;

export default styles;